// extracted by mini-css-extract-plugin
export default {"agreed":"MarketplaceNewNotice_agreed__zUaeF","notice":"MarketplaceNewNotice_notice__4vTdw","redIcon":"MarketplaceNewNotice_redIcon__r1tLd"};